export default "__VITE_ASSET__tkqwCty___"